import React, { useEffect, useState } from "react";
import { Container, Card, Button, Typography, Grid, CardActions, LinearProgress, Divider, Skeleton, Dialog } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";

import { useUserDetailsQuery, useUserDeleteMutation, useDisableUserMutation } from "services/user";
import { useOrgDetailsQuery } from "services/org";
import { useGetRoleByCodeQuery } from "services/role";
import { useSelector, useDispatch } from "react-redux";
import { resetRequestId } from 'api/user';

import { useUserCognitoDetailsQuery } from 'services/user';
import { useSubscriptionDetailsQuery } from "services/subscription";
import moment from 'moment-timezone';
import SubscriptionButton from "./button";
import { setSubscription } from "api/subscription";

const SubscriptionDetails = (props) => {

    const { userId } = useParams();
    const requestId = useSelector(state => state.user.requestId);
    const subscription = useSelector(state => state.subscription);


    const { userDetails } = useUserDetailsQuery(
        {
            id: userId,
            requestId: requestId
        },
        {
            skip: !userId,
            selectFromResult: ({ data }) => ({
                userDetails: data || {}
            })
        }
    );

    const { subscriptionDetails } = useSubscriptionDetailsQuery({ priceId: userDetails.priceId },
        {
            skip: !userDetails.priceId,
            selectFromResult: ({ data }) => ({
                subscriptionDetails: data || {}
            })
        }
    );



    return (
        <React.Fragment>
            <Container maxWidth={false} sx={{ backgroundColor: "#e0dcdcff!important", margin: "10px 0" }} >
                <Grid container justifyContent={'space-between'} alignItems={'center'}>
                    <Typography variant="h6" sx={{ fontWeight: "bold", margin: "15px 0" }}>Subscription Plan Details</Typography>
                    <SubscriptionButton />
                </Grid>
            </Container>
            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                <Grid item md={2}>
                    <Typography variant="h5">Subscription Plan:</Typography>
                </Grid>
                <Grid item md={4}>
                    <Typography variant="h6">{subscriptionDetails?.product?.name}</Typography>
                </Grid>
                <Grid item md={2}>
                    <Typography variant="h5">Subscription Date:</Typography>
                </Grid>
                <Grid item md={4}>
                    <Typography variant="h6">{subscriptionDetails?.price?.created ? moment.unix(subscriptionDetails?.price?.created).tz('America/Los_Angeles').format('MMM D, YYYY') : ''}</Typography>
                </Grid>
            </Grid>
            <Divider sx={{ margin: "10px" }} />
            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                <Grid item md={2}>
                    <Typography variant="h5">Subscription Frequency:</Typography>
                </Grid>
                <Grid item md={4}>
                    <Typography variant="h6">{subscriptionDetails?.price?.recurring?.interval || ''}</Typography>
                </Grid>
                <Grid item md={2}>
                    <Typography variant="h5">Subscription Amount:</Typography>
                </Grid>
                <Grid item md={4}>
                    <Typography variant="h6">{subscriptionDetails?.price?.unit_amount ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(subscriptionDetails?.price?.unit_amount / 100) : ''}</Typography>
                </Grid>
            </Grid>
            <Divider sx={{ margin: "10px" }} />
            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                <Grid item md={2}>
                    <Typography variant="h5">Trial Period:</Typography>
                </Grid>
                <Grid item md={4}>
                    <Typography variant="h6">{subscriptionDetails?.price?.recurring?.trial_period_days ? `${subscriptionDetails?.price?.recurring?.trial_period_days} days` : ''}</Typography>
                </Grid>
                <Grid item md={2}>
                    <Typography variant="h5">OEM:</Typography>
                </Grid>
                <Grid item md={4}>
                    <Typography variant="h6">{subscriptionDetails?.price?.metadata?.oem ? subscriptionDetails?.price?.metadata?.oem === "true" ? "Enabled" : "Disabled" : ''}</Typography>
                </Grid>
                <Divider sx={{ margin: "10px" }} />
            </Grid>
        </React.Fragment>

    )


}

export default SubscriptionDetails;